import { render, staticRenderFns } from "./postponeDetail.vue?vue&type=template&id=502fff1a&scoped=true"
import script from "./postponeDetail.vue?vue&type=script&lang=js"
export * from "./postponeDetail.vue?vue&type=script&lang=js"
import style0 from "./postponeDetail.vue?vue&type=style&index=0&id=502fff1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502fff1a",
  null
  
)

export default component.exports